export class User {
    uid: string = localStorage.getItem('uid');
    fname: string;
    lname: string;
    email: string;
    created: number;
    createdString: string;
    modified: number;
    modifiedString: string;
    path: string;
}